// Shared constants
export const SOURCE_LAYER = 'power_outages';
export const SOURCE_ID = 'power-outages';
export const REFRESH_INTERVAL_SECONDS = 60 * 10; // 10 minutes
export const MIN_ZOOM = 9;

// Item layer constants
export const ITEM_SHADOW_LAYER_ID = 'power-outages-item-shadow';
export const ITEM_BACKGROUND_LAYER_ID = 'power-outages-item-background';
export const ITEM_SELECTED_BACKGROUND_LAYER_ID =
  'power-outages-item-selected-background';
export const ITEM_ICON_LAYER_ID = 'power-outages-item-icon';

// Area layer constants
export const AREA_FILL_LAYER_ID = 'power-outages-area-fill';
export const AREA_STROKE_LAYER_ID = 'power-outages-area-stroke';
export const AREA_SELECTED_FILL_LAYER_ID = 'power-outages-area-selected-fill';
export const AREA_SELECTED_STROKE_LAYER_ID =
  'power-outages-area-selected-stroke';
